import { availabilityStatusEnum } from '@msc-b2c/interfaces/enums';

export const shopOBSMyMSCResponseMock = {
  availabilityStatus: availabilityStatusEnum.AVAILABLE,
  code: 'PCABIN',
  deliveryDate: '2025-09-01',
  description: 'per cabin test',
  isSurprise: false,
  type: 'CAPACK',
  prices: {
    taxes: {
      afterDiscount: '0.00',
      beforeDiscount: '0.00',
    },
    total: {
      afterDiscount: '176.68',
      beforeDiscount: '176.68',
    },
    perPassenger: [
      {
        isApplicable: true,
        number: 1,
        age: 43,
        total: {
          beforeDiscount: '176.68',
          afterDiscount: '176.68',
        },
        taxes: {
          afterDiscount: '0.00',
          beforeDiscount: '0.00',
        },
      },
    ],
  },
};
